import { animateNumbers } from './animateNumber';
import textFit from 'textfit';

('use strict');

/**
 * ## Numbers
 * - Animation des nombres du blocs Numbers
 */
const number = {
	init(switcher) {
		if (switcher && document.querySelector('.number')) {
			// REDIMENTIONNE LE TEXTE AVEC TEXTFIT

			document.querySelectorAll('.number__number').forEach((number) => {
				console.log(number);
				if(number.classList.contains('keynumber')) {
					// block key numbers
					textFit(number, {
						multiline: false,
						detectMultiLine: false,
						minFontSize: 40,
						maxFontSize: 160,
						reProcess: true
					});

				} else {
					if (window.matchMedia('(max-width: 1024px)').matches) {
						// block number
						textFit(number, {
							multiline: false,
							detectMultiLine: false,
							minFontSize: 20,
							maxFontSize: 160,
							reProcess: true
						});

						// REDUIRE L'ESPACE AVEC LE TEXTE EN DESSOUS SI LE TEXTE EST TRES GRAND ( PROBLEME DE HAUTEUR DE LIGNE)
						let fontSize = number.querySelector('.textFitted').style.fontSize;
						number.querySelector('.textFitted').style.maxHeight = 'calc(' + fontSize + ' / 1.25)';
					} else {
						textFit(number, {
							multiline: false,
							detectMultiLine: false,
							minFontSize: 24,
							maxFontSize: 240,
							reProcess: true
						});
					}
				}

				this.numbers = document.querySelectorAll('.number');

				// ANIMATION AU SCROLL
				new wap_actionIfVisible(this.numbers);
			});
		}
	}
};

class wap_actionIfVisible {
	constructor(elements, actionStart) {
		this.options = { threshold: [ 0.2 ] };
		this.observer = new IntersectionObserver(this.action.bind(this), this.options);
		this.elements = elements;
		this.actionStart = actionStart;
		this.start();
	}

	start() {
		for (let element of this.elements) {
			this.observer.observe(element);
		}
	}

	action(items) {
		items.forEach((item) => {
			if (item.intersectionRatio > 0.2 && item.target.querySelector('.number__number').classList.contains('hidden')) {
				animateNumbers(item.target.querySelector('.number__number span b'));
				
				if (item.target.querySelector('.number__number .textFitted ')) {
					item.target.querySelector('.number__number').classList.remove('hidden');
				}
			}
			// else if (item.intersectionRatio < 0.2) {
			// 	if (item.target.querySelector('.number__number .textFitted')) {
			// 		item.target.querySelector('.number__number').classList.add('hidden');
			// 	}
			// }
		});
	}
}

export default number;
